module YVR.Utilities.Flights {
	// Dependencies
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;


	// Default options
	const SERVICE_URL = `/${i18n.getCurrentLanguage()}/_api/Flights`;
	//for local testing
	//const SERVICE_URL = '/files/calgary-delayed.json';

	/**
	 * Get the flight data from the gateway warpper.
	 * @param id The flight ID.
	 * @returns {obj} A jQuery promise object.
	 */
	export function getFlightByFlightId(flightId: string | string[]): JQueryPromise<IFlightCollection> {
		// If the number is not an array, make it an array.
		if (!Array.isArray(flightId)) {
			flightId = [flightId];
		}

		// Create an OData filter using the array of flight IDs.
		const $filter = flightId.map((id) => `(FlightID eq '${id}')`).join(' or ');

		return $.get({
			url: SERVICE_URL,
			data: {
				$filter
			},
			success(data) {
				logger.log('[flights][getFlight] Successfully retrieved flight data.');
			}
		});
	}

	/**
	 * Get the flight data from the gateway warpper using flight numbers.
	 * @param number The flight number.
	 * @returns {obj} A jQuery promise object.
	 */
	export function getFlightByFlightNumber(flightNumber: string | string[]): JQueryPromise<IFlightCollection> {
		// If the number is not an array, make it an array.
		if (!Array.isArray(flightNumber)) {
			flightNumber = [flightNumber];
		}

		// Create an OData filter using the array of flight IDs.
		const data = {
			$filter: flightNumber.map((id) => `(FlightNumber eq '${id}')`).join(' or '),
			$orderby: 'FlightType,FlightScheduledTime'
		};

		return $.get({
			url: SERVICE_URL,
			data,
			success() {
				logger.log('[flights][getFlightByFlightNumber] Successfully retrieved flight data.');
			}
		});
	}
}
